// https://stackoverflow.com/a/22023833/4400318
export function fileSize(bytes, decimals = 2) {
    const exp = (Math.log(bytes) / Math.log(1024)) | 0;
    const result = (bytes / 1024 ** exp).toFixed(exp === 0 ? 0 : decimals);
    return exp === 0 ? `${result} bytes` : `${result} ${'KMGTPEZY'[exp - 1]}B`; // \u200b could be used but it goes against Intacct's style guide
}
export const capitalizeFirstLetter = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
export function replaceAll(input, search, replacement) {
    return input.replaceAll(search, replacement);
}
//# sourceMappingURL=strings.js.map